import { useEffect } from "react";

const SITE = "https://myurbanpassport.com";
const DEFAULT_TITLE = "Urban by VeerGi | The World of Punjabi Food";
const DEFAULT_DESC = "Urban by VeerGi — The World of Punjabi Food. Explore the menu, hear the stories, earn Urban Points. Lincoln Park & Hoffman Estates, Chicago.";

// Route-level head manager: title, description, canonical, robots and one JSON-LD block.
export const useSeo = ({ title, description, path, jsonLd, noindex = false } = {}) => {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    document.title = title ? `${title} — Urban by VeerGi` : DEFAULT_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.content = description || DEFAULT_DESC;
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = SITE + (path || window.location.pathname);
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = "noindex, nofollow";  // whole site is out of search engines (owner order, June 2026)
    let script = null;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "route");
      script.text = ld;
      document.head.appendChild(script);
    }
    return () => {
      document.title = DEFAULT_TITLE;
      if (desc) desc.content = DEFAULT_DESC;
      if (robots) robots.content = "noindex, nofollow";
      if (script) script.remove();
    };
  }, [title, description, path, noindex, ld]);
};
